<template>
  <section>
    <img class="title-logo" alt="Lil' Spoonfuls" src="../assets/lilspoonfuls_logo.svg" />

    <div v-if="isLoaded === false">
      <div class="instagram-container">
        <div class="instagram-block" v-for="item in [0,1,2,3,4,5]" :key="item">
          <div class="instagram-image">
            <img class="loader" alt="Loading" src="../assets/loader.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="instagram-container">
      <div class="instagram-block" v-for="item in data" :key="item.id">
        <transition 
          appear 
          appear-active-class="fade-enter-active"
          @before-appear="beforeAppear"
          @appear="appear"
          @after-appear="afterAppear">
          <a :href="item.permalink">
            <img v-if="item.media_type === 'IMAGE'" class="instagram-image" v-bind:src="item.media_url" />
            <img v-if="item.media_type === 'CAROUSEL_ALBUM'" class="instagram-image" v-bind:src="item.media_url" />
            <!-- <img v-if="item.media_type === 'VIDEO'" class="instagram-image" v-bind:src="item.thumbnail_url" /> -->
            <video v-if="item.media_type === 'VIDEO'" muted autoplay="autoplay" class="instagram-image">
              <source v-bind:src="item.media_url" type="video/webm">
              <source v-bind:src="item.media_url" type="video/mp4">
              Sorry, your browser doesn't support embedded videos.
            </video>
          </a>
        </transition>
      </div>
    </div>
    <a href="https://instagram.com/lil_spoonfuls"><img class="instagram-glyph" src="../assets/instagram-glyph.png" />
    <p>follow us at lil_spoonfuls<br /></p></a>
  </section>
</template>

<script>
export default {
  name: 'InstagramFeed',
  props: {
    title: String,
    descripton: String
  },
  data() {
    return {
      isLoaded: false,
      data: {}
    }
  },
  beforeMount() {
    this.url = "https://condescending-lamarr-4b38f5.netlify.app/.netlify/functions/lilspoonfulsInstagram"
    this.data = null
    this.getInstagramFeed()
  },
  methods: {
    async getInstagramFeed(){
      const res = await fetch(this.url)
      const data = await res.json()
      this.data = data.data
      this.isLoaded = true;
    },
    beforeAppear: function() {
      console.log('beforeAppear')
    },
    appear: function() {
      console.log('appear!')
    },
    afterAppear: function() {
      console.log('afterAppear!')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    color: #555555;
    text-transform: none;
    text-decoration: none;
  }
  .loader {
    height: 100%;
    max-width: 225px;
  }
  .title-logo {
    width: 300px;
    max-width: 60%;
    margin-bottom: 24px;
  }
  .instagram-container {
    margin: 0 auto;
    width: 1220px;
    max-width: 95%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .instagram-block {
    width: 380px;
    max-width: 80%;
    margin: 0 auto 24px;
    -webkit-box-shadow: 1px 2px 5px 3px rgba(0,0,0,0.25);
    -moz-box-shadow: 1px 2px 5px 3px rgba(0,0,0,0.25);
    box-shadow: 1px 2px 5px 3px rgba(0,0,0,0.25);
    height: 380px;
    overflow: hidden;
    /* height: 425px; */
  }
  .instagram-image {
    width: calc(100% - 20px);
    margin: 10px auto;
    display: block;
  }
  .instagram-glyph {
    width: 64px;
  }
  .fade-enter-active {
  animation: go 2s;
}

@keyframes go {
  from {
    background: #fff;
  }
  to {
    background: #999;
  }
}
</style>
